"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrayHasOne = arrayHasOne;
exports.last = last;
exports.lastItems = lastItems;
function arrayHasOne(arr) {
    return arr.length > 0;
}
function last(arr) {
    return arr[arr.length - 1];
}
function lastItems(arr, numberOfItems, logger) {
    var validatedNumber = numberOfItems;
    if (validatedNumber < 0) {
        logger === null || logger === void 0 ? void 0 : logger.error('ERROR: Unexpected Codepath Reached - Last Items should be called with a number >= 0');
        validatedNumber = 0;
    }
    if (validatedNumber === 0) {
        return [];
    }
    return arr.slice(-validatedNumber);
}
